<template>
  <div class="form-wrapper">
    <form v-if="!submitted && !submitError"
          class="form"
          @submit.prevent="submitForm">
      <div class="form-group">
        <input v-model.trim="name"
               name="name"
               class="form-control"
               :placeholder="namePlaceholder">

        <div v-if="!$v.name.required && submitAttempted"
             class="error">
          Please enter your name
        </div>
      </div>

      <div class="form-group">
        <input v-model.trim="email"
               name="email"
               type="email"
               class="form-control"
               :placeholder="emailPlaceholder">

        <div v-if="!$v.email.required && submitAttempted"
             class="error">
          Please enter your email address
        </div>
      </div>

      <div class="form-group">
        <textarea v-model="message"
                  name="message"
                  class="form-control message-input"
                  :placeholder="messagePlaceholder"
                  rows="5"></textarea>

        <div v-if="!$v.message.required && submitAttempted"
             class="error">
          Please enter a message
        </div>
      </div>

      <div class="form-group">
        <button class="btn btn-accent-3 btn-submit"
                type="submit">
          {{ submitButtonLabel }}
        </button>
      </div>
    </form>
    <div v-if="submitted && !submitError"
         class="form-feedback">
      <span class="icon icon-success">
        <font-awesome-icon icon="check-circle"
                           role="presentation"></font-awesome-icon>
      </span>
      <h3 class="submit-success">
        Thank you!
      </h3>
      <p>Your message has been received.</p>
    </div>
    <div v-if="submitError"
         class="form-feedback">
      <span class="icon icon-error">
        <font-awesome-icon icon="exclamation-circle"
                           role="presentation"></font-awesome-icon>
      </span>
      <h3 class="submit-error">
        Oh no!
      </h3>
      <p>Something went wrong whilst sending your message.</p>
      <p>
        Please email us at
        <a href="mailto:info@educationcompany.co.uk">
          info@educationcompany.co.uk
        </a>.
      </p>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import qs from "qs";
import Log from "~/modules/log";

export default {
  name: "ContactForm",
  props: {
    namePlaceholder: {
      type: String,
      default: "Name"
    },
    emailPlaceholder: {
      type: String,
      default: "Email"
    },
    messagePlaceholder: {
      type: String,
      default: "Message"
    },
    submitButtonLabel: {
      type: String,
      default: "Send"
    }
  },
  data () {
    return {
      name: null,
      email: null,
      message: null,
      submitAttempted: false,
      submitError: false,
      submitted: false
    };
  },
  methods: {
    submitForm () {
      this.submitAttempted = true;

      if ( !this.$v.$invalid ) {
        const url = "/umbraco/Surface/ContactSurface/Submit";
        const formData = {
          __RequestVerificationToken: this.$csrfToken,
          name: this.name,
          email: this.email,
          message: this.message
        };

        axios.post( url, qs.stringify( formData ) )
          .then( response => {
            if ( response.data === true ) {
              this.name = "";
              this.email = "";
              this.message = "";

              this.submitAttempted = false;
              this.submitted = true;
            } else {
              throw Error( "Bad response" );
            }
          } )
          .catch( ( error ) => {
            this.submitError = true;

            Log.error( "Error submitting contact form", error, "Contact" );
            Log.email( {
              url: window.location.href,
              errorDescription: "There was an error submitting the contact form",
              errorData: formData
            } );
          } );
      }
    }
  },
  validations: {
    name: {
      required
    },
    email: {
      required
    },
    message: {
      required
    }
  }
};
</script>

<style lang="less" scoped>

</style>
